import React from 'react';

export default function UrlCell({ value }) {
  if (!value) return <span />;

  return (
    <a href={value} target="_blank" rel="noopener noreferrer" className="cm-cell-url">
      <i className="fas fa-external-link-alt" /> {value}
    </a>
  );
}
